import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { PATH } from '../../../constants/path';
import { COOKIE_KEY_REDIRECT_AFTER_LOGIN } from '../../../constants/cookie';

import { loginUser, resetForm } from '../../../services/authentication/login/actions';

import {
    FormComponent,
    TextInputFieldComponent,
    PasswordInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import { SuccessInfoComponent } from '../../form/SuccessInfoComponent';

import './LoginFormComponent.scss';

class LoginFormComponent extends React.Component {
    componentDidUpdate(prevProps) {
        const { resetForm, errorSubmit } = this.props;

        if (errorSubmit) {
            setTimeout(() => {
                resetForm();
            }, 5000);
        }
    }

    submit = data => {
        const { loginUser, currentPath } = this.props;
        loginUser(data, () => {
            this.props.history.push(currentPath ? currentPath : PATH.HOME_PATH);
            if (sessionStorage.getItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN)) {
                this.props.history.push(sessionStorage.getItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN));
                sessionStorage.removeItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN);
            }
        });
    };

    render() {
        const {
            errorMessage,
            requestSubmit,
            successSubmit,
            errorSubmit,
            i18nForm,
            i18nLogin
        } = this.props;
        if (!successSubmit) {
            return (
                <FormComponent
                    form="login-form"
                    onSubmit={this.submit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    initialValues={{}}
                    className="login-form"
                    submitText={i18nLogin.CONNECT_ME}>
                    <TextInputFieldComponent
                        name="login"
                        placeholder={i18nForm.PLACEHOLDER_EMAIL}
                        isRequired
                    />
                    <PasswordInputFieldComponent
                        name="password"
                        placeholder={i18nForm.PLACEHOLDER_PASSWORD}
                        noDefaultValidation
                        isRequired
                    />
                    <LegendFieldComponent classNameInputContainer="small txtright">
                        <LocalizedNavLink to={PATH.FORGOTTEN_PASSWORD_PATH}>
                            {i18nForm.PASSWORD_FORGOTTEN}
                        </LocalizedNavLink>
                    </LegendFieldComponent>
                    <React.Fragment>
                        {errorMessage && (
                            <LegendFieldComponent classNameInputContainer="color-err">
                                {errorMessage}
                            </LegendFieldComponent>
                        )}
                    </React.Fragment>
                </FormComponent>
            );
        } else {
            return (
                <SuccessInfoComponent>
                    <p>{i18nLogin.LOGIN_SUCCESS}</p>
                </SuccessInfoComponent>
            );
        }
    }
}

LoginFormComponent.propTypes = {
    currentPath: PropTypes.string.isRequired
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        errorMessage: state.authentication.error || '',
        requestSubmit: state.authentication.fetching || false,
        errorSubmit: !isEmpty(state.authentication.error),
        successSubmit: state.authentication.isAuthenticated,
        i18nForm: state.i18n.feature.form,
        i18nLogin: state.i18n.page.LOGIN
    };
};

const mapDispatchToProps = {
    loginUser,
    resetForm
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginFormComponent));



// WEBPACK FOOTER //
// ./src/components/authentication/login/LoginFormComponent.js